const moveDynamicCartButtons = () => {
  const editButtons = document.querySelectorAll('.key-cart-edit-btn');
  
  editButtons.forEach(button => {
    // Safety check: stop if it's already in the right place
    if (button.parentElement.classList.contains('lightly-spaced-row')) return;
    
    // THE FIX: Target the data attribute wrapper that actually holds both the button and the item details
    const parentContainer = button.closest('[data-merge-list-item]'); 
    
    if (parentContainer) {
      // Find the lightly-spaced-row div inside this specific wrapper
      const targetDiv = parentContainer.querySelector('.lightly-spaced-row');
      
      if (targetDiv) {
        // Move the button
        targetDiv.appendChild(button);
      }
    }
  });
};

// Keep the observer to catch the app injecting the button dynamically
const observer = new MutationObserver((mutationsList) => {
  for (let mutation of mutationsList) {
    if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
      moveDynamicCartButtons();
    }
  }
});

observer.observe(document.body, { 
  childList: true, 
  subtree: true 
});

// Run it once immediately just in case it's already rendered
moveDynamicCartButtons();